import { render, staticRenderFns } from "./DigitalMailboxEmailList.vue?vue&type=template&id=1f11535c"
import script from "./DigitalMailboxEmailList.vue?vue&type=script&lang=js"
export * from "./DigitalMailboxEmailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports